import React from 'react';
import { BackButton } from '../../../../../Components/Utils/Buttons';
import ViewIcon from '../../../../../Components/Icons/ViewIcon';
import { Link, useLocation, useParams } from 'react-router-dom';
import Breadcrumb from '../../../../../Components/Utils/Breadcrumb';
import { useFormik } from 'formik';

function ViewInspectionApprove() {
  const { insIdsurvey } = useParams();
  const {state} = useLocation();
  const viewData = state.data||{};

  console.log("View ",viewData);
  
  
  

  const formik = useFormik({
    initialValues: {},
    onSubmit: () => {}
  });

  // Choose form list based on insIdsurvey param

  return (
    <div className="w-full h-full px-4 py-2 overflow-hidden">
      <div className="w-full sm:flex justify-between items-center">
        <Breadcrumb
          items={[
            { name: "Forms Approve", link: `/settings/formsApprove/inspection` },
            { name: "Forms" },
          ]}
        />
        <div className="flex justify-end">
          <BackButton />
        </div>
      </div>

      <div className="w-full h-full bg-white mt-4 mx-auto rounded-md overflow-y-auto">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full max-h-[calc(100vh-200px)] overflow-y-auto">
            {
              viewData?.formList.length > 0 ? (
                <div className="w-full p-4">
                  <h2 className="text-xl font-semibold mb-4">{viewData?.label||"-"}</h2>
                  <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {viewData?.formList.map((form) => (
                      <div key={form.id} className="mb-2 bg-slate-100 p-4 rounded-md shadow-sm hover:shadow-md transition-shadow text-xs flex items-center ">
                        <input type='checkbox' checked={form?.enabled} />
                        <Link
                          to={`/settings/formsApprove/survey/view/${insIdsurvey}/${form.id}`}
                          className="text-baseColor-primary font-medium  flex items-center"
                        >
                          <span className="ml-2">{form.name}</span>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="p-4 text-center text-gray-500">
                  No forms available for this survey.
                </div>
              )
            }
          </div>
        </form>
      </div>
    </div>
  );
}

export default ViewInspectionApprove;
